import type { IValidatorResult } from "@/types/FormEngine/validation";

export function isTreeTable(toBeDetermined: any): toBeDetermined is ITreeTable {
  if ((toBeDetermined as ITreeTable).MaxRepetition && (toBeDetermined as ITreeTable).MaxRepetition > 1 && (toBeDetermined as ITreeTable).IsTable) {
    return true;
  }
  return false;
}
export function isTreeSection(toBeDetermined: any): toBeDetermined is ITreeElement {
  if ((toBeDetermined as ITreeTable).MaxRepetition && (toBeDetermined as ITreeTable).MaxRepetition == 1 && !(toBeDetermined as ITreeTable).IsTable && !(toBeDetermined as ITreeTable).IsOverlay) {
    return true;
  }
  return false;
}
export function isTreeOverlay(toBeDetermined: any): toBeDetermined is ITreeElement {
  if ((toBeDetermined as ITreeTable).MaxRepetition && (toBeDetermined as ITreeTable).MaxRepetition == 1 && !(toBeDetermined as ITreeTable).IsTable && (toBeDetermined as ITreeTable).IsOverlay) {
    return true;
  }
  return false;
}
export function isTreeField(toBeDetermined: any): toBeDetermined is ITreeField {
  if (
    !(toBeDetermined as ITreeTable).HasHiddenCaption &&
    !(toBeDetermined as ITreeTable).PagedSection &&
    !(toBeDetermined as ITreeTable).MaxRepetition
  ) {
    return true;
  }
  return false;
}
export function isControl(toBeDetermined: any): toBeDetermined is ITreeField {
  if (
    (toBeDetermined as ITreeField).LDT &&
    (toBeDetermined as ITreeField).LDT.FieldType !== "Button" &&
    (toBeDetermined as ITreeField).LDT.FieldType !== "Label"
  ) {
    return true;
  }

  return false;
}
export function isOptionBased(toBeDetermined: any): toBeDetermined is ITreeField {
  if (
    (toBeDetermined as ITreeField).LDT.FieldType === "Autocomplete" ||
    (toBeDetermined as ITreeField).LDT.FieldType === "ComboBox" ||
    (toBeDetermined as ITreeField).LDT.FieldType === "RadioButtonListSection" ||
    (toBeDetermined as ITreeField).LDT.FieldType === "RadioButtonList"
  ) {
    return true;
  }

  return false;
}

export function isValidatorResult(toBeDetermined: any): toBeDetermined is IValidatorResult {
  return (toBeDetermined?.isValid !== undefined && toBeDetermined?.message !== undefined );
}
export function NotEmpty(value: any): boolean {
  if (Array.isArray(value)) {
    return value.length > 0;
  } else {
    return value != undefined && value !== "" && value !== "--";
  }
}
/* declare function translate(
  dottedString: DottedLanguageObjectStringPaths
): string;
 */
export function nestedObjectGetUpdate(data: any, field: any, value: any) {
  let schema = data; // a moving reference to internal objects within obj
  const pList = field.split(".");
  const len = pList.length;
  for (var i = 0; i < len - 1; i++) {
    var elem = pList[i];
    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }
  if (!value) {
    return schema[pList[len - 1]];
  }
  schema[pList[len - 1]] = value;
}

export function debounce(fn: Function, delay: number) {
  let timeoutID: null | number = null;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutID as number);
    timeoutID = setTimeout(() => fn.apply(this, args), delay);
  };
}
export function hashCode(string: string): number {
  var hash = 0,
    i,
    chr;
  if (string.length === 0) return hash;
  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
